import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import {
  clickTracker,
  getContractTypeVal,
  getProjectId,
  getSourceValue,
  getTextWithNoSpace,
  getUserType,
  handleJdPayRedirection,
  handleRedirection,
  trackerObj,
  trackUserType,
} from '../../lib/common';
import { handlePopup, handleSetFaqData } from '../../reducersAndActions/actions/appStateActions';
import { logger, onClickEvent } from '../../lib/gaAnalytics';
import { useAppState } from '../../contexts/appState';
import { useAuth } from '../../contexts/auth';
import { getCsPortalLog } from '../../lib/logger';
import useClickAwayListener from '../../hooks/useClickAwayLitsner';
import { handleImpressionsTrack } from '../../api';

export default function OthersPopup({
  handleClosePopup,
  othersData,
  setAlert,
  handleFaqRedirection,
  setSelectedBannerType,
  id,
}) {
  const [, appDispatch] = useAppState();
  const source = getSourceValue();
  const navigate = useNavigate();
  const [authState] = useAuth();
  const { type } = authState;
  const queryParams = new URLSearchParams(window.location.search);
  const activeBannerFlag = sessionStorage.getItem('activeBannerFlag');
  const ref = useRef(null);
  const projectId = getProjectId();
  const contractType = getContractTypeVal(projectId);

  useClickAwayListener(ref, () => {
    handleClosePopup();
  });

  const handleClick = async (option) => {
    handlePopup(appDispatch, {});
    handleSetFaqData(appDispatch, {
      faqData: [],
    });
    if (id === 'banner') {
      setSelectedBannerType(option?.title);
      sessionStorage.setItem('bannerType', option?.title);
      handleClosePopup(option?.title);
      sessionStorage.setItem('activeBannerFlag', option?.title);
      if (projectId === 'csportal') {
        const bannerTrackType =
          option?.title === 'Mobile Banner'
            ? 'mobilebanner'
            : option?.title === 'JDRR Certificate'
              ? 'jdrrCertificate'
              : 'webbanner';
        const liVal = 'click';
        const liTrd = `cta_${bannerTrackType}`;
        const faqTypeVal = '';
        const othersDataArr = [];
        const llTrd = `issue_${bannerTrackType}`;
        await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersDataArr, llTrd, authState);
      }
    } else {
      try {
        onClickEvent(`CSMain-${type}`, option.title, option.title);
        if (getUserType?.[contractType]) {
          onClickEvent(
            `CSMain-${getUserType?.[contractType]}-${getTextWithNoSpace(option?.title)}`,
            `${getUserType?.[contractType]}-${getTextWithNoSpace(option?.title)}`,
            `${getUserType?.[contractType]}-${getTextWithNoSpace(option?.title)}`,
          );
        }
        document.body.style.overflow = 'unset';
        if (queryParams?.get('vertical') === 'leadDashBoard') {
          await clickTracker(`CS-FAQ-leadDashBoard-Others-${option?.title || ''}`, 'leadDashBoard');
        }
        if (trackUserType?.[contractType]) {
          await clickTracker(`issue_${trackerObj?.[option?.key]}`, `${trackUserType?.[contractType]}_issue`);
        }
        if (option.type === 'faq' || (projectId === 'genio' && ['jd_pay', 'cat'].includes(option.key))) {
          if (
            (projectId === 'csportal' && option?.key === 'JD-Pay') ||
            (projectId === 'genio' && option.key === 'jd_pay')
          ) {
            handleJdPayRedirection();
            return;
          }

          handleFaqRedirection(option);
        } else if (option.type === 'redirect') {
          if (projectId === 'csportal') {
            const liVal = 'click';
            const liTrd = `issue_${trackerObj?.[option?.key]}`;
            const faqTypeVal = '';
            const othersDataArr = [];
            const llTrd = '';
            await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersDataArr, llTrd, authState);
          }
          let finalUrl = '';
          if (option?.key === 'grievanceRedressal') {
            navigate('/csportal/grievance');
            return;
          }
          finalUrl = source === '2' && option.source2Url ? option.source2Url : option.url;

          await logger(
            'B-CSPORTAL',
            getCsPortalLog('others redirect', source, '', {
              url: `${finalUrl}&source=${source}`,
              msg: '',
              source,
            }),
            true,
          );
          handleRedirection(source, finalUrl, true);
        }
      } catch (err) {
        try {
          window.location = option.url ? `${option.url}&source=${source}` : '';
        } catch (err2) {
          setAlert({
            message: 'Something went wrong!',
            status: false,
          });
        }
      }
    }
  };

  useEffect(() => {
    document.body.style.overflow = 'hidden';
  }, []);

  return (
    <section className="cs_modal csfaq_pop">
      <div className="cs_modal_content cs_modal_animation cs_modal_up" ref={ref}>
        <div className="cs_modal_body">
          <div className="pop_faq_header">
            <div className="popcsfaq_headtxt font15 fw600 color111 popup-heading-div pt-20 pl-20 pr-20">
              {id === 'banner' ? 'Select Option' : 'Others'}
              <div>
                <div
                  className="modal_close csicon"
                  onClick={() => handleClosePopup()}
                  aria-label="Close Modal"
                  type="button"
                  tabIndex={0}
                  role="button"
                  onKeyDown={() => {}}
                />
              </div>
            </div>
          </div>

          <ul className="popcsfaq_listgroup pl-20 pr-20 pb-20">
            {othersData &&
              othersData.map((each, idx) => (
                <li className="popcsfaq_listgroup_item" key={idx}>
                  <div
                    tabIndex={0}
                    role="button"
                    onKeyDown={() => {}}
                    onClick={() => handleClick(each)}
                    className="popcsfaq_listgroup_text"
                  >
                    <div
                      className={`listgroup_text_title font14 fw500 ${
                        id === 'banner' && each.title === activeBannerFlag ? 'color007' : 'color111'
                      }`}
                    >
                      {each.title}
                    </div>
                  </div>
                </li>
              ))}
          </ul>
        </div>
      </div>
    </section>
  );
}

OthersPopup.propTypes = {
  handleClosePopup: PropTypes.func,
  handleFaqRedirection: PropTypes.func,
  othersData: PropTypes.array,
  setAlert: PropTypes.func,
  setSelectedBannerType: PropTypes.func,
  id: PropTypes.string,
};
